export enum ZIndexLayer {
  Default = 10,
  Dropdown = 900,
  Modal = 1000,
}
